
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_931QotsJ2ruFPr2eL9chukmkPRZMGIgHMyI7ki9ZGMgWAMeta } from "/tmp/build_d00c02dc/pages/Cases/Overview/[id].vue?macro=true";
import { default as _91id_934FF1iQA8liDi0MMCQqHwNheH8Sonw1NK_nMLPZduK1gMeta } from "/tmp/build_d00c02dc/pages/Service Requests/Overview/[id].vue?macro=true";
import { default as indexQogC8VTmR1BGVbE2THlntCyAZU8BrYWPIddjalPqa3YMeta } from "/tmp/build_d00c02dc/pages/Cases/Overview/index.vue?macro=true";
import { default as _91id_93hIq2yZ8pfVnSO00s_hw4m6cQcustgoJZy4l47KrEWXsMeta } from "/tmp/build_d00c02dc/pages/Companies/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93JWm5do7_6IIXZRfbr_rKiQfspkB7E6PTMARayT94l6EMeta } from "/tmp/build_d00c02dc/pages/Companies/Overview/Operations/[id].vue?macro=true";
import { default as _91id_93YgGdO_obvxtTfAg8xIJQQKKxiqghojNX7eaN_T7vtX8Meta } from "/tmp/build_d00c02dc/pages/Companies/Overview/Sales/[id].vue?macro=true";
import { default as indexSb1mIO6BBak8B_4NAjxliSFnB_hfx8INPrjAp4_04ZYMeta } from "/tmp/build_d00c02dc/pages/Companies/Overview/Activities/index.vue?macro=true";
import { default as indexZw4p2COQ_BU_chSITUAo9f1eBOWpq7caxjoavs8_E7cMeta } from "/tmp/build_d00c02dc/pages/Companies/Overview/Operations/index.vue?macro=true";
import { default as indexwWMUhKgoGUdXnXQkOfY1_tAQZ_hxAwo84QYOfq7b428Meta } from "/tmp/build_d00c02dc/pages/Companies/Overview/Sales/index.vue?macro=true";
import { default as Overview7dFT4M_NJxu6F_RdPt_FVfIqdeDDmQ3LBVTQfNzPEugMeta } from "/tmp/build_d00c02dc/pages/Companies/Overview.vue?macro=true";
import { default as _91id_93VlA9_IFTvv2ZpNi79OWdufiK6Qgqbjdz6dTscKm7Dm4Meta } from "/tmp/build_d00c02dc/pages/Home/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93GXlaLiQVj0__msRinC2KT0PEG0gpJfMGvRsgQp7GVNAMeta } from "/tmp/build_d00c02dc/pages/Home/Overview/Operations/[id].vue?macro=true";
import { default as _91id_93vF61GNv02_pOH3WOg3FSK7jxF4ITf9iPcNCLNnVu8zIMeta } from "/tmp/build_d00c02dc/pages/Home/Overview/Sales/[id].vue?macro=true";
import { default as _91id_93PY2MCTbtG4n8VtPuNFXnvIl83EoVVrnqVhjX12sAYv8Meta } from "/tmp/build_d00c02dc/pages/Home/Overview/Splits/[id].vue?macro=true";
import { default as index4VS_O_SBnD8zTH1ENupHy2xFVrDZ0ZwEQ89KIZPMw8kMeta } from "/tmp/build_d00c02dc/pages/Home/Overview/Activities/index.vue?macro=true";
import { default as index_OK5zdg3u2JYI2ZjOdgHbUAUPwHWNhrZ_OFPACp4yfMMeta } from "/tmp/build_d00c02dc/pages/Home/Overview/Operations/index.vue?macro=true";
import { default as indexzeELFyJNK_kaNNHgTel83709xXhzJxE7jO5Ai_xL5wcMeta } from "/tmp/build_d00c02dc/pages/Home/Overview/Sales/index.vue?macro=true";
import { default as index1hwZ8UJNDUl7fn_lt3komLheZcRVIWceIo8YjIVIpSIMeta } from "/tmp/build_d00c02dc/pages/Home/Overview/Splits/index.vue?macro=true";
import { default as OverviewIY9IO1z_0x0vmqrEEnFOVHGp_8GyiJGv26uX9njPFLUMeta } from "/tmp/build_d00c02dc/pages/Home/Overview.vue?macro=true";
import { default as _91id_939cJeaMrcFIZC8sYmvfOm1ElJmgd3_9pUDyhBTdULLtMMeta } from "/tmp/build_d00c02dc/pages/Opportunities/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93rd421ILfFppwkQg4vlgfPTQCrggj_kk93B0SE3p4MOoMeta } from "/tmp/build_d00c02dc/pages/Opportunities/Overview/Operations/[id].vue?macro=true";
import { default as _91id_93crJY2lylWbxSiyA2GDM7JY7QEC9DU1oNsiX__uqEas4Meta } from "/tmp/build_d00c02dc/pages/Opportunities/Overview/Sales/[id].vue?macro=true";
import { default as indexQAcdhVTB_s34xRTeRLBUtIBlOHEGPY7Godd7kIrw6VMMeta } from "/tmp/build_d00c02dc/pages/Opportunities/Overview/Activities/index.vue?macro=true";
import { default as indexR6PioR27F7hHesPyCE2Ao863mjfnSS_XRhntxgFTF7AMeta } from "/tmp/build_d00c02dc/pages/Opportunities/Overview/Operations/index.vue?macro=true";
import { default as indexF7PYkEaSSe9IwLB46BnBh9ri255FV7XkMd3fYfXqSDwMeta } from "/tmp/build_d00c02dc/pages/Opportunities/Overview/Sales/index.vue?macro=true";
import { default as OverviewuCmdzFyuHh1m_ol_n4Pu7LjErdYCGzHOZZN2oICqDkMMeta } from "/tmp/build_d00c02dc/pages/Opportunities/Overview.vue?macro=true";
import { default as _91id_93HEBIV2ksgHIZpLi8inIK2RSvjgbWd8vdkzfYpYsyX4UMeta } from "/tmp/build_d00c02dc/pages/Orders/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93WiMPnSif6wakbWvhjSwbdfO5GgYGAZucPsHdXJiWqbUMeta } from "/tmp/build_d00c02dc/pages/Orders/Overview/Sales/[id].vue?macro=true";
import { default as index_QdMV4ROo1I5_kZ4c2n_cEGswcU5gdsTZYDauL0_oogMeta } from "/tmp/build_d00c02dc/pages/Orders/Overview/Activities/index.vue?macro=true";
import { default as indexihf7JReCaeaBeEAe1glSwri_K_7c9UY_MtdkU_FL6PQMeta } from "/tmp/build_d00c02dc/pages/Orders/Overview/Sales/index.vue?macro=true";
import { default as OverviewU3OllmktEuy9988ugxESeULWKVpe8DYjR3Sc53xc37EMeta } from "/tmp/build_d00c02dc/pages/Orders/Overview.vue?macro=true";
import { default as indexW6QpIrEPhhoQBh1BdpT_cJMCu73fxJ_94_UiuIry7HUMeta } from "/tmp/build_d00c02dc/pages/Service Requests/Overview/index.vue?macro=true";
import { default as _91id_93i3eWa8HNvmgyLowa9dm3Bd_3gaRiJYrmOF5aBG0LbJsMeta } from "/tmp/build_d00c02dc/pages/Suppliers/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93cMbs3oqFLvsnj_f0N8UTyXv2mllLRxGwcROmqGtA3fEMeta } from "/tmp/build_d00c02dc/pages/Suppliers/Overview/Sales/[id].vue?macro=true";
import { default as indexp6T3Yo2fitaYjOa38FxYPBlsVWKtUnpD3GofrrebIK4Meta } from "/tmp/build_d00c02dc/pages/Suppliers/Overview/Activities/index.vue?macro=true";
import { default as index_54GR_fI8PucL38VwfEgkThbRlBCZmgGyNPqGZ_7CVUMeta } from "/tmp/build_d00c02dc/pages/Suppliers/Overview/Sales/index.vue?macro=true";
import { default as OverviewX_Sosb7NrvSARPUi0MBrw9Q33PZWqOqcX_CEyoqKD_cMeta } from "/tmp/build_d00c02dc/pages/Suppliers/Overview.vue?macro=true";
import { default as _91id_93lM_FkIHUzR1FTNHRzunljBE59XRyT6rlsoh33GxO8nQMeta } from "/tmp/build_d00c02dc/pages/Accounts/[id].vue?macro=true";
import { default as _91id_93fl_4CPve7LusfCzFJaEQPbs_VQ3Qmda7dxGNmSaShosMeta } from "/tmp/build_d00c02dc/pages/Field Sets/[id].vue?macro=true";
import { default as _91id_9377TVXV_MID_CyzQ8tnv8B0MSwKDSmlIL_KaIKVbJN64Meta } from "/tmp/build_d00c02dc/pages/Industries/[id].vue?macro=true";
import { default as _91id_93DIgw4aTqtPbiMaTuQ5M1x0amajJtB_lpn0eBEawhZHgMeta } from "/tmp/build_d00c02dc/pages/Locations/[id].vue?macro=true";
import { default as _91id_93C1n6UPXyLpicIEYh0riksY9PbyMnSraeOjCGai1lCOwMeta } from "/tmp/build_d00c02dc/pages/Product Categories/[id].vue?macro=true";
import { default as _91id_937sGHMU8nzCriphBvT6AadYBo2aRhTHFxJLknptCss2sMeta } from "/tmp/build_d00c02dc/pages/Product Groups/[id].vue?macro=true";
import { default as _91id_93lPvpErPLh4qjnptJmmRzYHyh_5PLEj_WzG88Xx5j_4cMeta } from "/tmp/build_d00c02dc/pages/Product Subcategories/[id].vue?macro=true";
import { default as _91id_93SmmDwuyuNhPS4Fr9Nlp1rX4DZzEkunC9edsDOZZ5CVwMeta } from "/tmp/build_d00c02dc/pages/Products/[id].vue?macro=true";
import { default as _91id_93XL1A0JPpQ75RiqFaP6Ez_cMOpppK_4La0KqL39THSJAMeta } from "/tmp/build_d00c02dc/pages/Projects/[id].vue?macro=true";
import { default as _91id_93uzMROrjFQNem5CFBja9zpAa5ciwM5T4BAprin3nzFwoMeta } from "/tmp/build_d00c02dc/pages/SupplierProducts/[id].vue?macro=true";
import { default as _91id_93Zz5_20I48wlNsHnEICVgBgWFuiRKo9gI1H7WOKM5QdUMeta } from "/tmp/build_d00c02dc/pages/Team Members/[id].vue?macro=true";
import { default as _91id_93vEB__30pC1Ow4wGLa9J5QRhw2_P4xiyZ1d5VLSBf7o4Meta } from "/tmp/build_d00c02dc/pages/TSDs/[id].vue?macro=true";
import { default as index871GyqE1EfW4a_u072a__uWdRIR8hQy5Ga20YVNNm6wMeta } from "/tmp/build_d00c02dc/pages/Accounts/index.vue?macro=true";
import { default as indexqlILqHxHxKYaHRLGybYDBbecyPO9QE2Z_TGIAZgM4XsMeta } from "/tmp/build_d00c02dc/pages/Case Types/index.vue?macro=true";
import { default as indextlZWNZfbSLs1ah1EJk_Blu5F2DZ8u_448zC2pSulny8Meta } from "/tmp/build_d00c02dc/pages/Cases/index.vue?macro=true";
import { default as indexkSDzKLcFnNX6Csk4YclSKj04CqVuT5ojmNKq01Z3MqEMeta } from "/tmp/build_d00c02dc/pages/Companies/index.vue?macro=true";
import { default as indexuYIehNfS4NjqcHGfhuASXAEYAD6HvjTPm8EocFF61c8Meta } from "/tmp/build_d00c02dc/pages/Company Contact Roles/index.vue?macro=true";
import { default as indexmXcIJSazo_vALAQhgZxbEDNmerVcChOT94eGayzp6LEMeta } from "/tmp/build_d00c02dc/pages/Contacts/index.vue?macro=true";
import { default as indexXyT0pVQLdAfvt3cqh8XEyYVffcULQLLc_X6QFy619FAMeta } from "/tmp/build_d00c02dc/pages/Dashboard/index.vue?macro=true";
import { default as indexFg6WSK_gdLziqOPTEkLNG1vkvrOJJG5CEtlayeFAVLAMeta } from "/tmp/build_d00c02dc/pages/Field Sets/index.vue?macro=true";
import { default as indexS_rv1sGI60wcqOV5EMm4yh1aHhUShTkdw1r5xAgzk54Meta } from "/tmp/build_d00c02dc/pages/Groups/index.vue?macro=true";
import { default as indexo1ead0HPtXy6tfDYE96KUS2WPyFym8_qt3q4qtMvPdoMeta } from "/tmp/build_d00c02dc/pages/Home/index.vue?macro=true";
import { default as indexxcvFKXnvzoUscymS14jmcyjEtdVL_fXXsNAFQT7CbtYMeta } from "/tmp/build_d00c02dc/pages/Industries/index.vue?macro=true";
import { default as indexQHSrKMN67ZJzRwfATxBR9yVzVtBUZ1flZgE1Az8pHqMMeta } from "/tmp/build_d00c02dc/pages/Lead Source Campaigns/index.vue?macro=true";
import { default as indexfCTWdfw__d_hzeGSYXIJnzcTFqZdXXGeWjXHiAiBTrwMeta } from "/tmp/build_d00c02dc/pages/Lead Source Contacts/index.vue?macro=true";
import { default as indexaGd_u1Xf96y5lEib8f59mvAefp__EOb3ups49SZN4UoMeta } from "/tmp/build_d00c02dc/pages/Lead Source Events/index.vue?macro=true";
import { default as index13d4_OiwlV_xNckCgLw3n69_2qpA9nivHKmOzJGfbEMMeta } from "/tmp/build_d00c02dc/pages/Location Types/index.vue?macro=true";
import { default as indexbRgUAYDZbIorDgLy_Z7lir_4PYngMDUK3fN7QSuKHmsMeta } from "/tmp/build_d00c02dc/pages/Login/index.vue?macro=true";
import { default as indexUGsk0nhU_OPUdbuXeT6WnfAmLduKCp_tNJyS6SgkyIYMeta } from "/tmp/build_d00c02dc/pages/Opportunities/index.vue?macro=true";
import { default as index_Jk1lhZpqFfHP6DB3ekK_Cb8AxBKbkGFg69XbHHg1n0Meta } from "/tmp/build_d00c02dc/pages/Opportunity Stages/index.vue?macro=true";
import { default as indexJEeWj_ELMG6v5BQ7OP_yEQ_6mbwOpG91ZGn_9aPajIwMeta } from "/tmp/build_d00c02dc/pages/Orders/index.vue?macro=true";
import { default as indexL5_VyiFER4J_Zd1Xyn6xeAnQb3bfK_V8DC0Z6TFk0JUMeta } from "/tmp/build_d00c02dc/pages/Payables/index.vue?macro=true";
import { default as indexYo4qau1JokumufqcbgCjCn804Un_2tsntfrxzpbgSXAMeta } from "/tmp/build_d00c02dc/pages/Persons/index.vue?macro=true";
import { default as index4s3JcTQJZgz_KlU6dgLAlOvMsgays3Kkg4KxIDjS8r4Meta } from "/tmp/build_d00c02dc/pages/Product Categories/index.vue?macro=true";
import { default as indexiiLEktOSNv6K7oQ7AV4zZeBdnSLaVDFZd2gcxy3t_EAMeta } from "/tmp/build_d00c02dc/pages/Product Groups/index.vue?macro=true";
import { default as indexdrb0bc1rR_tDWdWQ_aMMApQVjChCFctzD1QvEOqKx5kMeta } from "/tmp/build_d00c02dc/pages/Product Subcategories/index.vue?macro=true";
import { default as index502O2JQkP2nSKrPmGF3Rbox8t0Ml4K65NjEAVm5Ht0YMeta } from "/tmp/build_d00c02dc/pages/Projects/index.vue?macro=true";
import { default as indexcVrHd8UOQ5pQITx9mDG2R5T2X8vc9ABlJQuALmbE2hUMeta } from "/tmp/build_d00c02dc/pages/Receivables/index.vue?macro=true";
import { default as indexTd2GGRG08X0m7Plvl4QkH4H0vsouKKaJ763seZDVNaUMeta } from "/tmp/build_d00c02dc/pages/Service Request Types/index.vue?macro=true";
import { default as indexX_0aAZe_DBh3yAJGPNXnSCNGlmxtrrnvjaJnh9h74t8Meta } from "/tmp/build_d00c02dc/pages/Service Requests/index.vue?macro=true";
import { default as indexOsOpf_euD338Qa7AHk1KXq_0knWUD4MPOj18jluBcgMMeta } from "/tmp/build_d00c02dc/pages/Settings/index.vue?macro=true";
import { default as indexRyfrsVjJWbVMvMMgtM3eRkJifglu8um_Svy3LU9V5MAMeta } from "/tmp/build_d00c02dc/pages/Supplier Contact Roles/index.vue?macro=true";
import { default as indexIQ1XQ98GVOOTWxlzg__9rx09NEsOF3mkOXIZVWMpxfUMeta } from "/tmp/build_d00c02dc/pages/Suppliers/index.vue?macro=true";
import { default as index0WY_do4b4VlUGFhjJJguOP0ApRB4Fb5MDYUISE52LMQMeta } from "/tmp/build_d00c02dc/pages/Team Members/index.vue?macro=true";
import { default as indexdzW2c7bKpVprv_dzBNgkb64oIv8qRl0PCPH3QRxiOWsMeta } from "/tmp/build_d00c02dc/pages/TSD Contact Roles/index.vue?macro=true";
import { default as indexZiY8OSnlPeagG8aIPz__5sJp9De7f29AOjw9Tk47_8EMeta } from "/tmp/build_d00c02dc/pages/TSDs/index.vue?macro=true";
import { default as indexDqU5Bzci23jykE4G99uMU5TFBNLYg3wzrQXXH1J0ijYMeta } from "/tmp/build_d00c02dc/pages/User/index.vue?macro=true";
import { default as indextgFQVrSWwbJibzGBBMi86g1f1TU5xydKdifs6GuMG5wMeta } from "/tmp/build_d00c02dc/pages/Users/index.vue?macro=true";
import { default as index98qTfwvGABVCtLR_2v8RT8INaIVLWyRR0fFFeVp25aEMeta } from "/tmp/build_d00c02dc/pages/index.vue?macro=true";
export default [
  {
    name: "Cases-Overview-id",
    path: "/Cases/Overview/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Cases/Overview/[id].vue")
  },
  {
    name: "Service Requests-Overview-id",
    path: "/Service%20Requests/Overview/:id()",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_d00c02dc/pages/Service Requests/Overview/[id].vue")
  },
  {
    name: "Cases-Overview",
    path: "/Cases/Overview",
    component: () => import("/tmp/build_d00c02dc/pages/Cases/Overview/index.vue")
  },
  {
    name: "Companies-Overview",
    path: "/Companies/Overview",
    component: () => import("/tmp/build_d00c02dc/pages/Companies/Overview.vue"),
    children: [
  {
    name: "Companies-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Companies/Overview/Activities/[id].vue")
  },
  {
    name: "Companies-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Companies/Overview/Operations/[id].vue")
  },
  {
    name: "Companies-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Companies/Overview/Sales/[id].vue")
  },
  {
    name: "Companies-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_d00c02dc/pages/Companies/Overview/Activities/index.vue")
  },
  {
    name: "Companies-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_d00c02dc/pages/Companies/Overview/Operations/index.vue")
  },
  {
    name: "Companies-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_d00c02dc/pages/Companies/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Home-Overview",
    path: "/Home/Overview",
    component: () => import("/tmp/build_d00c02dc/pages/Home/Overview.vue"),
    children: [
  {
    name: "Home-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Home/Overview/Activities/[id].vue")
  },
  {
    name: "Home-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Home/Overview/Operations/[id].vue")
  },
  {
    name: "Home-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Home/Overview/Sales/[id].vue")
  },
  {
    name: "Home-Overview-Splits-id",
    path: "Splits/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Home/Overview/Splits/[id].vue")
  },
  {
    name: "Home-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_d00c02dc/pages/Home/Overview/Activities/index.vue")
  },
  {
    name: "Home-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_d00c02dc/pages/Home/Overview/Operations/index.vue")
  },
  {
    name: "Home-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_d00c02dc/pages/Home/Overview/Sales/index.vue")
  },
  {
    name: "Home-Overview-Splits",
    path: "Splits",
    component: () => import("/tmp/build_d00c02dc/pages/Home/Overview/Splits/index.vue")
  }
]
  },
  {
    name: "Opportunities-Overview",
    path: "/Opportunities/Overview",
    component: () => import("/tmp/build_d00c02dc/pages/Opportunities/Overview.vue"),
    children: [
  {
    name: "Opportunities-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Opportunities/Overview/Activities/[id].vue")
  },
  {
    name: "Opportunities-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Opportunities/Overview/Operations/[id].vue")
  },
  {
    name: "Opportunities-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Opportunities/Overview/Sales/[id].vue")
  },
  {
    name: "Opportunities-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_d00c02dc/pages/Opportunities/Overview/Activities/index.vue")
  },
  {
    name: "Opportunities-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_d00c02dc/pages/Opportunities/Overview/Operations/index.vue")
  },
  {
    name: "Opportunities-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_d00c02dc/pages/Opportunities/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Orders-Overview",
    path: "/Orders/Overview",
    component: () => import("/tmp/build_d00c02dc/pages/Orders/Overview.vue"),
    children: [
  {
    name: "Orders-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Orders/Overview/Activities/[id].vue")
  },
  {
    name: "Orders-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Orders/Overview/Sales/[id].vue")
  },
  {
    name: "Orders-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_d00c02dc/pages/Orders/Overview/Activities/index.vue")
  },
  {
    name: "Orders-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_d00c02dc/pages/Orders/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Service Requests-Overview",
    path: "/Service%20Requests/Overview",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_d00c02dc/pages/Service Requests/Overview/index.vue")
  },
  {
    name: "Suppliers-Overview",
    path: "/Suppliers/Overview",
    component: () => import("/tmp/build_d00c02dc/pages/Suppliers/Overview.vue"),
    children: [
  {
    name: "Suppliers-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Suppliers/Overview/Activities/[id].vue")
  },
  {
    name: "Suppliers-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Suppliers/Overview/Sales/[id].vue")
  },
  {
    name: "Suppliers-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_d00c02dc/pages/Suppliers/Overview/Activities/index.vue")
  },
  {
    name: "Suppliers-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_d00c02dc/pages/Suppliers/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Accounts-id",
    path: "/Accounts/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Accounts/[id].vue")
  },
  {
    name: "Field Sets-id",
    path: "/Field%20Sets/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Field Sets/[id].vue")
  },
  {
    name: "Industries-id",
    path: "/Industries/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Industries/[id].vue")
  },
  {
    name: "Locations-id",
    path: "/Locations/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Locations/[id].vue")
  },
  {
    name: "Product Categories-id",
    path: "/Product%20Categories/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Product Categories/[id].vue")
  },
  {
    name: "Product Groups-id",
    path: "/Product%20Groups/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Product Groups/[id].vue")
  },
  {
    name: "Product Subcategories-id",
    path: "/Product%20Subcategories/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Product Subcategories/[id].vue")
  },
  {
    name: "Products-id",
    path: "/Products/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Products/[id].vue")
  },
  {
    name: "Projects-id",
    path: "/Projects/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Projects/[id].vue")
  },
  {
    name: "SupplierProducts-id",
    path: "/SupplierProducts/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/SupplierProducts/[id].vue")
  },
  {
    name: "Team Members-id",
    path: "/Team%20Members/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/Team Members/[id].vue")
  },
  {
    name: "TSDs-id",
    path: "/TSDs/:id()",
    component: () => import("/tmp/build_d00c02dc/pages/TSDs/[id].vue")
  },
  {
    name: "Accounts",
    path: "/Accounts",
    component: () => import("/tmp/build_d00c02dc/pages/Accounts/index.vue")
  },
  {
    name: "Case Types",
    path: "/Case%20Types",
    component: () => import("/tmp/build_d00c02dc/pages/Case Types/index.vue")
  },
  {
    name: "Cases",
    path: "/Cases",
    component: () => import("/tmp/build_d00c02dc/pages/Cases/index.vue")
  },
  {
    name: "Companies",
    path: "/Companies",
    component: () => import("/tmp/build_d00c02dc/pages/Companies/index.vue")
  },
  {
    name: "Company Contact Roles",
    path: "/Company%20Contact%20Roles",
    component: () => import("/tmp/build_d00c02dc/pages/Company Contact Roles/index.vue")
  },
  {
    name: "Contacts",
    path: "/Contacts",
    component: () => import("/tmp/build_d00c02dc/pages/Contacts/index.vue")
  },
  {
    name: "Dashboard",
    path: "/Dashboard",
    component: () => import("/tmp/build_d00c02dc/pages/Dashboard/index.vue")
  },
  {
    name: "Field Sets",
    path: "/Field%20Sets",
    component: () => import("/tmp/build_d00c02dc/pages/Field Sets/index.vue")
  },
  {
    name: "Groups",
    path: "/Groups",
    component: () => import("/tmp/build_d00c02dc/pages/Groups/index.vue")
  },
  {
    name: "Home",
    path: "/Home",
    meta: {"middleware":["home-redirect"]},
    component: () => import("/tmp/build_d00c02dc/pages/Home/index.vue")
  },
  {
    name: "Industries",
    path: "/Industries",
    component: () => import("/tmp/build_d00c02dc/pages/Industries/index.vue")
  },
  {
    name: "Lead Source Campaigns",
    path: "/Lead%20Source%20Campaigns",
    component: () => import("/tmp/build_d00c02dc/pages/Lead Source Campaigns/index.vue")
  },
  {
    name: "Lead Source Contacts",
    path: "/Lead%20Source%20Contacts",
    component: () => import("/tmp/build_d00c02dc/pages/Lead Source Contacts/index.vue")
  },
  {
    name: "Lead Source Events",
    path: "/Lead%20Source%20Events",
    component: () => import("/tmp/build_d00c02dc/pages/Lead Source Events/index.vue")
  },
  {
    name: "Location Types",
    path: "/Location%20Types",
    component: () => import("/tmp/build_d00c02dc/pages/Location Types/index.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: indexbRgUAYDZbIorDgLy_Z7lir_4PYngMDUK3fN7QSuKHmsMeta || {},
    component: () => import("/tmp/build_d00c02dc/pages/Login/index.vue")
  },
  {
    name: "Opportunities",
    path: "/Opportunities",
    component: () => import("/tmp/build_d00c02dc/pages/Opportunities/index.vue")
  },
  {
    name: "Opportunity Stages",
    path: "/Opportunity%20Stages",
    component: () => import("/tmp/build_d00c02dc/pages/Opportunity Stages/index.vue")
  },
  {
    name: "Orders",
    path: "/Orders",
    component: () => import("/tmp/build_d00c02dc/pages/Orders/index.vue")
  },
  {
    name: "Payables",
    path: "/Payables",
    component: () => import("/tmp/build_d00c02dc/pages/Payables/index.vue")
  },
  {
    name: "Persons",
    path: "/Persons",
    component: () => import("/tmp/build_d00c02dc/pages/Persons/index.vue")
  },
  {
    name: "Product Categories",
    path: "/Product%20Categories",
    component: () => import("/tmp/build_d00c02dc/pages/Product Categories/index.vue")
  },
  {
    name: "Product Groups",
    path: "/Product%20Groups",
    component: () => import("/tmp/build_d00c02dc/pages/Product Groups/index.vue")
  },
  {
    name: "Product Subcategories",
    path: "/Product%20Subcategories",
    component: () => import("/tmp/build_d00c02dc/pages/Product Subcategories/index.vue")
  },
  {
    name: "Projects",
    path: "/Projects",
    component: () => import("/tmp/build_d00c02dc/pages/Projects/index.vue")
  },
  {
    name: "Receivables",
    path: "/Receivables",
    component: () => import("/tmp/build_d00c02dc/pages/Receivables/index.vue")
  },
  {
    name: "Service Request Types",
    path: "/Service%20Request%20Types",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_d00c02dc/pages/Service Request Types/index.vue")
  },
  {
    name: "Service Requests",
    path: "/Service%20Requests",
    component: () => import("/tmp/build_d00c02dc/pages/Service Requests/index.vue")
  },
  {
    name: "Settings",
    path: "/Settings",
    component: () => import("/tmp/build_d00c02dc/pages/Settings/index.vue")
  },
  {
    name: "Supplier Contact Roles",
    path: "/Supplier%20Contact%20Roles",
    component: () => import("/tmp/build_d00c02dc/pages/Supplier Contact Roles/index.vue")
  },
  {
    name: "Suppliers",
    path: "/Suppliers",
    component: () => import("/tmp/build_d00c02dc/pages/Suppliers/index.vue")
  },
  {
    name: "Team Members",
    path: "/Team%20Members",
    component: () => import("/tmp/build_d00c02dc/pages/Team Members/index.vue")
  },
  {
    name: "TSD Contact Roles",
    path: "/TSD%20Contact%20Roles",
    component: () => import("/tmp/build_d00c02dc/pages/TSD Contact Roles/index.vue")
  },
  {
    name: "TSDs",
    path: "/TSDs",
    component: () => import("/tmp/build_d00c02dc/pages/TSDs/index.vue")
  },
  {
    name: "User",
    path: "/User",
    component: () => import("/tmp/build_d00c02dc/pages/User/index.vue")
  },
  {
    name: "Users",
    path: "/Users",
    component: () => import("/tmp/build_d00c02dc/pages/Users/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/build_d00c02dc/pages/index.vue")
  }
]